import React, { Component, PureComponent, useContext, useState, useEffect } from 'react';
import {NavLink, Link, Switch, Route, Redirect} from 'react-router-dom'
import {RootRouterContext} from '../../index.js'
import Contact from './Contact'
import Catering from './Catering'
import Taconight from './Taconight'
import Order from './Order'
import RestaurantMap from './ReataurantMap.js';
import Headers from './Headers'
// import AutoMenu from './AutoMenu'
import AutoMenu from '../../react/AutoMenu'
import CartBar from './CartBar'
import LocationsView from './LocationsView'
import FormJob from './FormJob'
import ScrollToTop from '../../react/ScrollToTop.js';
import BakeryVideo from "./BakeryVideo"
import FeaturedProducts from './FeaturedProducts.js';
import HamburgerMenu from './HamburgerMenu.js';
import MenuCategoriesPreview from './MenuCategoriesPreview.js';
import './index.scss'
import './altStyleA.scss'
import LogoBar from './svg/LogoBar'
import './ThemeToggle/theme_night.scss'
import {Helmet} from "react-helmet";
import MainNavigation from './MainNavigation.js';
import { InstagramEmbed } from 'react-social-media-embed';
import locationsData from './locationsData.js';
export const customOrderAppPaths = ["/menu", "/order"]
export const StickyTopBar = () => { return null }
 
export {locationsData as locations}

// merge locations data with locations metadata


export const pages = [
  {path: "/order", label: "Order"},
  {path: "/menu", label: "Menu"},
  {path: "/hqusers/storeRedirect/:anything", label: "Catering", hideFromNav: true, component: () => <Redirect to="/"></Redirect>},
]

export const multiSitePages = [
  // {path: "/catering", label: "Menu", component: Menu},
  // {path: "/catering", label: "Catering", component: Catering},
  {path: "/contact", label: "Contact", component: Contact},
  {path: "/catering", label: "Catering", component: Catering},
  {path: "/order", label: "Order", component: Order},
]

export function SiteNav ({shopId}) {

    const {rootHistory} = useContext(RootRouterContext)


    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav role="navigation" aria-label="navigation">
    
   
  </nav>
  </>
  )
}



export function MultilocationHome () {
  const [shops, setShops] = useState([])
  const [shop, setShop] = useState(null)
  let menuURL = `https://afoodapart.com/api/menu/blosom`
  // useEffect(() => {
  //   const fetchShops = async () => {
  //     // fetch 2 shops shiso and shisooaks

  //     const fetchShiso = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shiso`);
  //     const fetchShisooaks = fetch(`https://p39pffu1q4.execute-api.us-west-1.amazonaws.com/v18-sushi-mods/settings?r_id=shisooaks`);
      
  //     const [shisoResponse, shisooaksResponse] = await Promise.all([fetchShiso, fetchShisooaks]);
      
  //     const shisoData = await shisoResponse.json();
  //     shisoData.text.shopId = 'shiso'
  //     const shisooaksData = await shisooaksResponse.json();
  //     shisooaksData.text.shopId = 'shisooaks'
      
  //     setShops([shisoData.text, shisooaksData.text]);
  //   }
  //   fetchShops()
  // }, [0])
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await fetch(menuURL);
        const data = await response.json();
        console.log('Fetched menu data:', data.menu.subMenus);
        setShop(data);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };
    fetchMenu();
  }, []);

  // console.log("shops:", shops)


  const theme = "light"
  const heroLogoUrl = (theme !== 'dark') ?
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format" :
    "https://afag.imgix.net/the-kluckin-chicken/kluckin-chicken-logo-1.png?w=500&auto=format"

  return(
    <div className={"site-content pablitoschicken" + " " + theme}>
      <Headers></Headers>

      <div role="navigation" aria-label="primary" className="cart-wrapper">
      
            <div className="cart minimized">
              <div className="home-link-wrapper">
                <h2>
                  <Link to="/" 
                  aria-label={"Blosom Japanese Restaurant Los Angeles"}
                  className="home-link" aria-label="home page">
                         {/* <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/pablitos-pizza/logo.png?h=400&auto=format"}
                          alt="Pablito's Mexican Pizza"
                        /> */}
                    <img
                          className="nav-bar-logo"
                          src={"https://afag.imgix.net/blosom-japanese-restaurant/logo.png?w=1000&auto=format"}
                          alt="Blosom Japanese Restaurant Los Angeles"
                   />
                    {/* <span className="text-logo">{!logo && shop.name && shop.name.en}</span> */}
                  </Link>
                </h2>
      
              </div>
      
             
      
              <div className="site-nav-bar" >
                  <MainNavigation />

                  <a className="nav-bar-link call-to-action" href="/order" aria-label="order online for pickup or delivery (choose location)">
                    Order
                  </a>


           
              </div>


              
      
      
      
            </div>
          </div>


  
      <Switch>

        {multiSitePages.map((page) => (
          <Route key={page.path} path={page.path} component={page.component} />
        ))}
        <Route path="/" exact render={() => {
          return(<MultiHeader shops={shops} shop={shop}></MultiHeader>)
        }}></Route>
        <Route path="/hqusers/storeRedirect/:anything" render={() => {
          return(<Redirect to="/"></Redirect>)
        }}></Route>
        {/* <MultiHeader></MultiHeader> */}
      </Switch>
    </div>
  )
}



function MultiHeader({shops, shop}) {
  return (
    <div className="landing-page-wrapper">
    
      <div className="home-grid">
        {/* <BakeryVideo /> */}


        <div className="hero-image">
          <img src="https://afag.imgix.net/blosom-japanese-restaurant/hero.avif?w=1200&auto=format" alt="Blosom Japanese Restaurant Hero" />
        </div>
                  {/* <div className="logo-hero-block" ><div className="logo-hero-block-img-wrapper"><img src="https://afag.imgix.net/blosom-japanese-restaurant/hero-logo.png?w=1200&auto=format" alt="Blosom Japanese Restaurant" /></div></div> */}

        <div className="site-intro">
          <h2 className="header-text">
           BEST JAPANESE <br/>RESTAURANT IN <br/>LOS ANGELES
          </h2>
          
                 <p className='body-text'>
            We specialize in Ramen, Sushi, Specialty Rolls, Teriyaki, Gourmet Salad and Appetizer!
            </p>
            <p className='body-text'>
            We DELIVER!
            </p>
        </div>

        {/* 
        <h2 className="header-text">
          Featured Items
        </h2>

        <FeaturedProducts /> */}

        <div className="split-section" style={{
        
        }}>
          <div className="split-image" style={{
            flex: '1',
            backgroundImage: 'url(https://static.wixstatic.com/media/6185ed_80220740187b4667944a31e3f88ff62c~mv2.jpg/v1/fill/w_688,h_845,fp_0.50_0.50,q_85,enc_avif,quality_auto/6185ed_80220740187b4667944a31e3f88ff62c~mv2.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '400px'
          }}></div>
          <div className="split-content" style={{
            flex: '1',
            display: 'flex',
            backgroundColor: 'rgba(219, 38, 18, 0.9)',
            color: 'white',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '2rem',
            textAlign: 'center'
          }}>
            <h3 className="split-title" style={{ marginBottom: '1rem', fontSize: '1.8rem' }}>
              LA'S FAVORITE JAPANESE RESTAURANT!
            </h3>
            <p className="split-text">
              BLOSOM JAPANESE RESTAURANT is the place where great cooking and fantastic vibes meet. Our food is nutritious, delicious, and affordable, and we welcome diners young and old. Try it yourself—Stop by or pick up order today!
            </p>
            <p className="split-text">
              Explore Our Menu
            </p>
          </div>
        </div>


        {shop ? <MenuCategoriesPreview categories={shop.menu.subMenus} /> : null}

        <h2 className="header-text">
          Our Locations
        </h2>
        <LocationsView shops={shops} />
      </div>
    </div>
  );
}




export class Header extends PureComponent {
  render() {
    // console.log('header props:', this.props)
    const shopId = this.props.shopId
    const basePath = this.props.basePath
    const locationName = this.props.shopId === 'shiso' ? 'North Hollywood' : 'Sherman Oaks'


    const backgroundULRBase = (basePath === '/shermanoaks') ?
    "https://afag.imgix.net/the-kluckin-chicken/nuggets.jpeg?w=1200&auto=format"
    : "https://afag.imgix.net/the-kluckin-chicken/kluckin-ten.png?w=1200&auto=format"
    return (
      <div className="location-page">

      <Helmet>
        <title>Blosom Japanese | Order Online</title>
      </Helmet>
      
        <div className="top-banner" style={{
          // backgroundImage: `url(${backgroundULRBase})`,
          // backgroundColor: "rgb(238,143,33)",
          // background:  `url(${backgroundULRBase}), linear-gradient(180deg, rgba(238,143,33,1) 0%, rgba(226,90,39,1) 100%)`,
          // backgroundSize: "contain",
          // background: "black"
        }}> 

        </div>

       

      <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>

        <div className="ordering-menu">
          <AutoMenu
            subMenuFilter={subMenuFilter}
            altStyleA
            // tagsToShow={['pizza']}
            width={500}></AutoMenu>
        </div>
      </div>
    );
  }
}


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag || ''
  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isAllDayBreakfastMenu = tag.indexOf('breakfast') !== -1
  const isHidden = tag.indexOf('hidden') !== -1
  if (tag.indexOf('lunch') !== -1) {
    // thursday promo category
    if (isWeekday && (hours >= 11) && (hours < 16)) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('thursdays-only') !== -1) {
    // thursday promo category
    if (day === 4) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('tuesday-only') !== -1) {
    // thursday promo category
    if (day === 2) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-breakfast') !== -1) {
    if ((day === 1) || (day === 2)) {
      if ((hours > 0) && (hours < 16)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-dinner') !== -1) {
    return true
    // thursday promo category
    // if ((day === 1) || (day === 2)) {
    //   if ((hours > 16)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
  }

  if (tag.indexOf('promo-wing-it-wed') !== -1) {
    // wednesday promo category
    if (day === 3) {
      return true
    } else {
      return false
    }
  }

  if (isHidden) {
    return false
  }

  if (isAllDayBreakfastMenu && isWeekday) {
    return false
  }


  return true
}